export default __webpack_public_path__ + "static/media/green_Omar_Siddique.46625519.png";